import React from "react";
import { ToggleButtonGroup, Box } from "@mui/material";

const PaymentStatusToggle = (props: any) => {
  const { active, setActive } = props;

  const handleChange = (event: any, newStatus: any) => {
    if (newStatus !== null) setActive(newStatus);
  };

  return (
    <ToggleButtonGroup
      value={active}
      exclusive
      onChange={handleChange}
      sx={{
        backgroundColor: "#18C5A7",
        borderRadius: "0px",
        overflow: "hidden",
        border: "1px solid #11C89B",
      }}
    >
      <Box
        component="button"
        onClick={() => setActive(0)}
        sx={{
          flex: 1,
          backgroundColor: active === 0 ? "#18C5A7" : "#fff",
          color: active === 0 ? "#ffffff" : "#757575",
          fontWeight: "bold",
          textTransform: "none",
          padding: "10px 20px",
          border: "none",
          cursor: "pointer",
          position: "relative",
          //   clipPath: "polygon(0 0, 90% 0, 80% 100%, 0% 100%)",
          clipPath: "polygon(0 0, 100% 0, 85% 100%, 0% 100%)",
          transition: "background-color 0.3s ease",
          "&:hover": {
            backgroundColor: "#18C5A7",
            color: "#fff",
          },
        }}
      >
        Paid
      </Box>

      <Box
        component="button"
        onClick={() => setActive(1)}
        sx={{
          flex: 1,
          backgroundColor: active === 1 ? "#18C5A7" : "#fff",
          color: active === 1 ? "#ffffff" : "#757575",
          fontWeight: "bold",
          textTransform: "none",
          padding: "10px 20px",
          border: "none",
          cursor: "pointer",
          position: "relative",
          //   clipPath: "polygon(10% 0, 100% 0, 100% 100%, 20% 100%)",
          clipPath: "polygon(15% 0, 100% 0, 100% 100%, 0% 100%)",
          transition: "background-color 0.3s ease",
          "&:hover": {
            backgroundColor: "#18C5A7",
            color: "#fff",
          },
        }}
      >
        Overdue
      </Box>
    </ToggleButtonGroup>
  );
};

export default PaymentStatusToggle;
